import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowActions } from '@components/Modal/ModalWindowActions';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { useField } from '@hooks/useField';
import { useForm } from '@hooks/useForm';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IPasswordChangeRequest, useAuthService } from '@services/AuthService';
import { yup } from '@validations/Yup';
import React from 'react';
import { AlterarSenhaForm } from './AlterarSenhaForm';

export type AlterarSenhaModalProps = {
    modal: IModalWindow
}

export function AlterarSenhaModal ({ modal }: AlterarSenhaModalProps) {
    const loading = useLoading();
    const message = useMessage();
    const authService = useAuthService();

    const form = useForm<IPasswordChangeRequest>({
        currentPass: useField(''),
        newPass: useField(''),
        confirmPass: useField('')
    });

    const validation = yup.object().shape({
        currentPass: yup.string().required(),
        newPass: yup.string().required(),
        confirmPass: yup.string().required()
    });

    const handleConfirm = React.useCallback(() => {
        if (!loading.isLoading) {
            const values = form.getInputValues();

            validation.validate(values)
                .then(() => {
                    loading.start();
                    authService.changePassword(values)
                        .then(response => {
                            message.success("Senha alterada com sucesso");
                            modal.close();
                        })
                        .catch(e => {
                            message.handleResponse(e)
                                .badRequest(form.setErrorsFromServer)
                                .showException();
                        })
                        .finally(loading.stop);
                })
                .catch(form.setErrorsFromYup)
        }
    }, [authService, form, loading, message, modal, validation]);

    return (
        <ModalWindow
            modal={modal}    
            disabled={loading.isLoading}
            size="md"
        >
            <ModalWindowTitle
                title="Alterar Senha"
            />
            
            <ModalWindowContent>
                <AlterarSenhaForm 
                    form={form} 
                />
            </ModalWindowContent>

            <ModalWindowActions>
                <PrimaryButton onClick={handleConfirm} disabled={loading.isLoading}>Alterar Senha</PrimaryButton>
            </ModalWindowActions>

        </ModalWindow>
    )
}